import axios from 'axios'

import {
  Message
} from 'element-ui'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 900000 // request timeout
})
service.defaults.headers = {
  'content-type': 'application/x-www-form-urlencoded'
  // 'content-type': 'application/json'
}
service.defaults.crossDomain = true
service.interceptors.request.use(
  config => {
    // if (config.url.indexOf('/event/burst') > -1 || config.url.indexOf('/event/trig') > -1 || config.url.indexOf('/fileInfo/getFileInfo') > -1) {
    //   config.baseURL = process.env.VUE_APP_WS_BASE_API
    //   // config.headers['content-type'] = 'application/x-www-form-urlencoded'
    //   // config.data=qs.stringify(config.data)
    // }
    // else if(config.url.indexOf("/downloadInfo")>-1 || config.url.indexOf("/dataSetBase/download")>-1 || config.url.indexOf("/dataSetBase/openFile")>-1 || config.url.indexOf("/personSpace/downLoaddataSet")>-1){
    //   config.baseURL=process.env.VUE_APP_REQUEST_TARGET//线上注释
    // }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data

    // if the custom code is not 20000, it is judged as an error.
    if (res && res.code && res.code !== 20000) {
      if (res.code === 20001 || res.code === 401) {
        // 当前未登录或已经过期
        // Message({
        //   message: '请先登录',
        //   type: 'warning'
        // })
        // if (window.sessionStorage.getItem('sign') === 'asos_service') {
        //   window.location.href = process.env.VUE_APP_CAS_LOGIN_BACK
        // } else {
        //   window.location.href = process.env.VUE_APP_CAS_LOGIN_FRONT
        // }
      }
    //  else {
    //     Message({
    //       message: res.message || 'Error',
    //       type: 'error',
    //       duration: 5 * 1000
    //     })
    //     return Promise.reject(new Error(res.message || 'Error'))
    //   }
    }
    return res
  },
  error => {
    console.log('err' + error) // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js